import { Note, NoteTableActions } from '@/@types/note';
import {
  EmptyData,
  ErrorList,
  ListPlaceholder,
  ResponseDataHandle,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { Box } from '@mui/material';

import { NotesTable } from '../NotesTable';

type NotesListProps = {
  isLoading: boolean;
  isError: boolean;
  data?: { notes: Note[]; totalCount: number };
  sort?: 'asc' | 'desc';
  sortBy?: string;
  // eslint-disable-next-line no-unused-vars
  onSort: (column: string) => void;
  actions: NoteTableActions;
  pagination: ITablePaginationProps;
};

export function NotesList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: NotesListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder headers={['Título', 'Tipo', 'Ações']} />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter as observações." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <NotesTable
        data={data?.notes || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
